import PropTypes from 'prop-types';
import { useToggle } from 'usehooks-ts';
import { Card, CardHeader, Collapse, Stack } from '@mui/material';

import { ActionsMenu } from 'components/simple';

import { UserCardActions } from './UserCardActions';
import { UserCardContent } from './UserCardContent';

const styles = {
  card: ({ palette }, isInactive) => ({
    height: 'auto',
    padding: 1.5,
    backgroundColor: isInactive ? palette.colors.veryLightGrey : palette.colors.lightPale,
    border: `1px solid ${isInactive ? palette.colors.lightGrey : palette.colors.darkPale}`,
    borderRadius: 2.5,
  }),
  cardHeader: {
    height: 40,
    padding: 'unset',
    '.MuiCardHeader-action': {
      margin: 'unset',
    },
  },
};

export const UserMobileCard = ({ isInactive = false, actions, mobileInfo, customActionStyles = {} }) => {
  const [expanded, toggleExpanded] = useToggle();
  const isCollapsible = !!mobileInfo.additionalInfo?.length;

  return (
    <Card elevation={0} sx={(theme) => styles.card(theme, isInactive)}>
      <CardHeader action={<ActionsMenu options={actions} customStyles={customActionStyles} />} sx={styles.cardHeader} />

      <Stack spacing={1}>
        <UserCardContent info={mobileInfo.generalInfo} />

        {isCollapsible &&
          (!expanded ? (
            <UserCardActions expanded={expanded} toggleExpanded={toggleExpanded} />
          ) : (
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <UserCardContent info={mobileInfo.additionalInfo} />

              <UserCardActions expanded={expanded} toggleExpanded={toggleExpanded} />
            </Collapse>
          ))}
      </Stack>
    </Card>
  );
};

const actionPropTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  link: PropTypes.string,
  hideOption: PropTypes.bool,
};

const mobileInfoPropTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

UserMobileCard.propTypes = {
  isInactive: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      ...actionPropTypes,
      subItems: PropTypes.arrayOf(PropTypes.shape(actionPropTypes)),
    }),
  ).isRequired,
  mobileInfo: PropTypes.shape({
    generalInfo: PropTypes.arrayOf(PropTypes.shape(mobileInfoPropTypes)),
    additionalInfo: PropTypes.arrayOf(PropTypes.shape(mobileInfoPropTypes)),
  }).isRequired,
  customActionStyles: PropTypes.shape({
    option: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  }),
};
